import useAppSettings from './useAppSettings'
import { DUAL_ROLE_SWITCHER_FEATURE } from '../activeRole'

/**
 * Whether the institution lets a dual-role user open their OWN student record
 * while advising (view and create their own plans), lifting the self-record
 * guards. Requires BOTH: the dual-role switcher feature must be on for the
 * persona model to exist at all, and the `advisorViewOwnPlan` academic-planning
 * setting opts into the relaxed behavior on top of it.
 *
 * `advisorViewOwnPlan` is a typed Academic Planning setting (settings-service /
 * Customization Center), NOT an `adminSetting.features` flag — mirroring the
 * pattern used for other academic-planning toggles like readOnlyPlansForStudents.
 *
 * Note: this only reports the institution setting; callers still combine it
 * with `isDualRole` (and, where relevant, the active persona) at each guard.
 */
const useAdvisorCanViewOwnPlan = (): boolean => {
  const { adminSetting, academicPlanningSettings } = useAppSettings()
  const dualRoleEnabled = !!adminSetting?.features?.includes(DUAL_ROLE_SWITCHER_FEATURE)
  return dualRoleEnabled && !!academicPlanningSettings?.advisorViewOwnPlan
}

export default useAdvisorCanViewOwnPlan
